import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ComplianceCategoryStatsData } from '../models';

export interface ComplianceCategoryStatsSliceState {
  data: ComplianceCategoryStatsData;
  loading: boolean;
  error: string | null;
}

const initialState: ComplianceCategoryStatsSliceState = {
  data: null,
  loading: false,
  error: null,
};

const complianceCategoryStatsSlice = createSlice({
  name: 'complianceCategoryStats',
  initialState,
  reducers: {
    setData: (state, action: PayloadAction<ComplianceCategoryStatsData>) => ({
      ...state,
      data: action.payload,
    }),
    setLoading: (state, action: PayloadAction<boolean>) => ({
      ...state,
      loading: action.payload,
    }),
    setError: (state, action: PayloadAction<string | null>) => ({
      ...state,
      error: action.payload,
    }),
    fetchCategoryStats: (state) => ({
      ...state,
      error: null,
      loading: true,
    }),
  },
});

export { complianceCategoryStatsSlice };
